
	import BridgePhotosFolderView from '../../components/ViewTypes/BridgePhotosFolderView.vue'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component({
    components: {
      BridgePhotosFolderView
    }
  })

  export default class General extends Vue  {
    dialog = false
    galleryDialog = false
    editDateMenu = false
    selectedItem: any = {
      
    }
    headers = [
      { text: 'Date', value: 'date' },
      { text: 'Description', value: 'description' },
      { text: 'Notes', value: 'notes' },
      //{ text: 'URL', value: 'url' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]
    items: Array<object> = []
    editedIndex = -1
    editedItem: any = {
      id: null,
      date: '',
      description: '',
      notes: '',
      url: '',
      images: null,
      bridgeId: -1
    }
    defaultItem: any = {
      id: null,
      date: '',
      description: '',
      notes: '',
      url: '',
      images: null,
      bridgeId: -1
    }

    @Prop() readonly id!: object
    @Prop() readonly tab!: number

    //Methods
    public editItem(item: object ): void {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    }


    public close(): void {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }

    public deleteItem(item: object): void {
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteBridgePhoto', item)
    }

    public download(item: object): void {
      this.$store.dispatch('bridge/downloadBridgePhoto', item)
    }

    public loadFolder(item: object): void {
      this.selectedItem = item
      this.galleryDialog = true
    }

    public save(): void {
      this.editedItem.bridgeId = this.id
      if (this.editedIndex > -1) {
        this.$store.dispatch('bridge/updateBridgePhoto', this.editedItem)
        //Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.$store.dispatch('bridge/storeBridgePhoto', this.editedItem)
        //this.items.push(this.editedItem)
      }
      this.close()
    }

    //Getters
    get getBridgePhotos(): any {
      return this.$store.getters['bridge/getBridgePhotos']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getLoading(): boolean {
      return this.$store.getters['bridge/getLoading']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watchers
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.tab == 5 && this.galleryDialog == false) {
        this.$store.dispatch('bridge/getBridgePhotos', { id: this.id })
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getBridgePhotos')
    setItems(val: any) {
      this.items = val
    }
  }



